import { useTranslation } from "react-i18next"

export function Navbar() {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-2 border-b bg-background px-3 py-2">
      <img
        id="LogoImage"
        src="/images/visit_website.png"
        alt="Logo"
        className="h-8"
      />
      <span className="flex-1 text-lg font-semibold">{t("navbar.title")}</span>
    </div>
  )
}
